export default {
  addEmulator( {commit}, data ) {
    commit('addEmulator', data)
  },
  setEmulators( {commit }, data ) {
    commit('setEmulators', data)
  }
}
